import { BarriersChart } from '@/pages/funds/ic-report/components/primitives/charts/BarriersChart'
import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { beta } from '@/react-query/queries/ic-report/hooks'

export interface CapitalPreservationChartProps extends ICReportChartPrimitive {}

export const CapitalPreservationChart: React.FC<CapitalPreservationChartProps> = ({ params }) => {
  const query = beta.useCapitalProtectionBarriers(params)
  const data = query.data ?? []

  return <BarriersChart data={data} dataHandle={'barrier_level'} params={params} />
}
